var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66797 3.33329C8.66797 2.9651 8.36949 2.66663 8.0013 2.66663C7.63311 2.66663 7.33463 2.9651 7.33463 3.33329V7.33323L3.33464 7.33323C2.96645 7.33323 2.66797 7.63171 2.66797 7.9999C2.66797 8.36809 2.96645 8.66656 3.33464 8.66656L7.33463 8.66656V12.6666C7.33463 13.0348 7.63311 13.3333 8.0013 13.3333C8.36949 13.3333 8.66797 13.0348 8.66797 12.6666V8.66656L12.668 8.66656C13.0362 8.66656 13.3346 8.36809 13.3346 7.9999C13.3346 7.63171 13.0362 7.33323 12.668 7.33323L8.66797 7.33323V3.33329Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.9496aa3d23baae931a8b25a486785e7e.svg";
export { ForwardRef as ReactComponent };